import BaseListPage from "../../../../base/BaseListPage";
import withRouter from "../../../../utils/withRouter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import Search from "../../../../components/Search";
import Table from "../../../../components/Table";
import UnlockingListPresenter from "./UnlockingListPrensenter";
import Filters from "./components/Filters";

class UnlockingListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new UnlockingListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase(),
    );

    this.fieldsToDisplay = [
      "requestor",
      "record_requested",
      "request_number",
      "createdAt",
      "status",
    ];
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "access_request";
  }

  onClickViewItem(index) {
    this.presenter.onClickViewItem(index);
  }
  handleDateChange(event) {
    const selectedDate = event.target.value;
    this.presenter.onDate(selectedDate);
  }

  getActions() {
    return [
      {
        label: "View",
        onClick: this.onClickViewItem.bind(this),
        icon: "bi bi-eye",
      },
    ];
  }

  formatSchemaFields(fields) {
    return {
      // ...fields,
      requestor: {
        ...fields.requestor,
        type: "String",
        label: "Requestor",
      },
      record_requested: {
        ...fields.record_requested,
        type: "String",
        label: "Record Requested",
      },
      createdAt: {
        ...fields.createdAt,
        label: "Lock Date",
      },
      status: {
        ...fields.status,
        label: "Status",
      },
      request_number: {
        ...fields.request_number,
        label: "Request Number",
      },
    };
  }

  formatObject(objects) {
    const user = this.getCurrentUser();
    const isAdmin = user.roles?.some((role) => role.id === "admin");

    return objects.map((object, index) => {
      let updatedStatus = object.status;

      // If user is not an admin and not the approver
      // if (!isAdmin && object.approverName !== user.id) {
      //   if (object.status === "Request Granted") {
      //     updatedStatus = "Unlock Request Approved";
      //   } else {
      //     updatedStatus = "Request for Unlocking";
      //   }
      // }

      if (object.status === "Cancelled") {
        updatedStatus = "Cancelled";
      } else if (!isAdmin && object.approverName !== user.id) {
        if (object.status === "Request Granted") {
          updatedStatus = "Unlock Request Approved";
        } else {
          updatedStatus = "Request for Unlocking";
        }
      }

      // if (!isAdmin && object.approverName !== user.id) {
      //   if (object.status === "Cancelled") {
      //     updatedStatus = "Cancelled";
      //   } else if (object.status === "Request Granted") {
      //     updatedStatus = "Unlock Request Approved";
      //   } else {
      //     updatedStatus = "Request for Unlocking";
      //   }
      // }

      // If user is an admin, always keep the original status
      return {
        ...object,
        requestor: `${object?.requestor?.firstName || ""} ${object?.requestor?.middleName || ""} ${object?.requestor?.lastName || ""} ${object?.requestor?.alias || ""}`,
        record_requested: object.no_record
          ? ` ${object.no_record_requested?.firstName || ""} ${
              object.no_record_requested?.middleName || ""
            } ${object.no_record_requested?.lastName || ""} ${object.no_record_requested?.alias || ""} ${
              object.no_record_requested?.company || ""
            }`
          : `${object.record_requested?.firstName || ""} ${
              object.record_requested?.middleName || ""
            } ${object.record_requested?.lastName || ""} ${object.no_record_requested?.alias || ""} ${
              object.record_requested?.company || ""
            }`,
        status: updatedStatus,
      };
    });
  }

  searchName(where, merge) {
    console.log("where");
    this.presenter.searchName(where, merge);
  }

  onSearchStatus(query) {
    this.presenter.searchStatus(query);
  }

  // searchSubmit(where, merge) {
  //   console.log("www", where);
  //   this.presenter.searchNumberSubmit(where, merge);
  // }

  searchSubmit(where, merge) {
    console.log("www", where);

    if (where && where.$or && where.$or.length > 0) {
      // Extract the search value from the first $or condition that has a $regex
      let searchValue;
      for (let condition of where.$or) {
        const key = Object.keys(condition)[0];
        if (condition[key] && condition[key].$regex) {
          searchValue = condition[key].$regex;
          break;
        }
      }

      console.log("Search value extracted:", searchValue);

      if (searchValue) {
        // Create a new query that searches in the correct nested fields
        const newWhere = {
          $or: [
            { id: { $regex: searchValue, $options: "i" } },
            { requestor: { $regex: searchValue, $options: "i" } },
            { reason: { $regex: searchValue, $options: "i" } },
            { remarks: { $regex: searchValue, $options: "i" } },
            { approver_remarks: { $regex: searchValue, $options: "i" } },
            { status: { $regex: searchValue, $options: "i" } },
            { approverName: { $regex: searchValue, $options: "i" } },
            // Search in no_record_requested object fields
            // {
            //   "no_record_requested.firstName": {
            //     $regex: searchValue,
            //     $options: "i",
            //   },
            // },
            {
              no_record_requested: {
                firstName: {
                  $regex: searchValue,
                  $options: "i",
                },
              },
            },
            {
              "no_record_requested.middleName": {
                $regex: searchValue,
                $options: "i",
              },
            },
            {
              "no_record_requested.lastName": {
                $regex: searchValue,
                $options: "i",
              },
            },
            {
              "no_record_requested.company": {
                $regex: searchValue,
                $options: "i",
              },
            },
            // Search in record_requested object fields
            {
              "record_requested.firstName": {
                $regex: searchValue,
                $options: "i",
              },
            },
            {
              "record_requested.middleName": {
                $regex: searchValue,
                $options: "i",
              },
            },
            {
              "record_requested.lastName": {
                $regex: searchValue,
                $options: "i",
              },
            },
            {
              "record_requested.company": {
                $regex: searchValue,
                $options: "i",
              },
            },
          ],
        };

        this.presenter.searchNumberSubmit(newWhere, merge);
      } else {
        this.presenter.searchNumberSubmit(where, merge);
      }
    } else {
      this.presenter.searchNumberSubmit(where, merge);
    }
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count } = this.state;

    console.log("Objects: ", objects);
    return (
      <PageContainer
        title="Unlocking"
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <Filters
          // searchName={this.searchName.bind(this)}
          searchName={this.searchSubmit.bind(this)}
          searchSubmit={this.searchSubmit.bind(this)}
          onSearchStatus={this.onSearchStatus.bind(this)}
          onChangeDate={this.onChangeDate.bind(this)}
          schemas={this.getSchemas()}
          schema={schema}
        />

        <Table
          fields={this.formatSchemaFields(schema.fields)}
          objects={this.formatObject(objects)}
          collapsable
          progress={loading}
          actions={this.getActions.bind(this)}
          excludeFields={Object.keys(schema.fields).filter(
            (key) => !this.fieldsToDisplay.includes(key),
          )}
        />
      </PageContainer>
    );
  }
}

export default withRouter(UnlockingListPage);
